import React from 'react';
// Zustand
import { useStore } from "./zustand";
// Components
// import Canvas from "./ThreeD/Canvas";
import AlternateSlider from "./components/BillboardUI/AlternateSlider";
import ThemeUIController from "./components/ThemeUIController";
import LoadingController from "./components/LoadingController";
// import useWindowSize from "./utility/hooks/useWindowSize";
// Styles
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    mainContent: {
        display: 'flex',
        width: '100%',
        height: '100%',
        //fontFamily: props => props.default_text_font,
        fontFamily: 'Montserrat, helvetica, sans-serif',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column-reverse',
            justifyContent: 'flex-end'
        }
    },
    billboard_content: {
        flexWrap: 'wrap',
        padding: '0 0 1rem 0',
        minHeight: '100%',
        height: 'auto',
        background: '#fff',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 0,
            borderTopWidth: '1.25rem',
        },
        [theme.breakpoints.up('md')]: {
            '&.has_no_pois': {
                paddingBottom: 0,
            },
        },
    },
    default_scene : {
        width: '100%',
        height: '100%'
    },
    billboard_scene: {
        width: '100%',
        height: 'auto',
        maxWidth: 'calc(100% - 415px)',
        position: 'relative',
        order: 1,
        opacity: 1,
        transition: 'all 0.4s ease-in',
        '.video_tab_active &': {
            opacity: 0,
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            minHeight: '52vh',
            order: 2,
            //zIndex: 1, TO DO
            //marginTop: '-1rem', TO DO
            //maxHeight: 320, TO DO
            //'& > div': {
            //    minHeight: 340, // viewer height in mobile for billboards TO DO
            '& canvas': {
                minHeight: 374, // viewer height in mobile for billboards
                height: '100% !important'
            },
            '.reviews_tab_active &, .video_tab_active &': {
                minHeight: 0,
                maxHeight: 0,
                overflow: 'hidden',
            },
        },
        [theme.breakpoints.up('md')]: {
            maxHeight: '65vh',
            '.has_no_options &': {
                maxWidth: '100%',
                maxHeight: '80vh',
                display: 'flex',
                width: '55%',
            },
            '.has_no_options & > div': {
                order: 1,
                minHeight: 550,
            },
            '.has_no_pois &': {
                maxHeight: 'calc(100vh - 2rem)',
            },
        },
    },
}));

export default function Main() {
    // const appInitialized = useStore(state => state.appInitialized); // Wait for model to load before bringing in UI
    const appInitialized = true;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const { billboards_enabled, variant_switch_enabled, billboard_variant_switch_enabled, active_tab } = useStore(state => state.scene_controls);
    const classes = useStyles(dynamic_text_settings);
    const reviews = useStore.getState().reviews;
    const actions = useStore(state => state.actions);
    const elementRef = React.useRef(null);

    React.useEffect(() => {
        if(!appInitialized) return;
        // TODO: potentially get rid of because no longer doing outside viewer variant changing
        const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        const eventer = window[eventMethod];
        const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function (event) {       
            if(event.data?.type === 'levar_message') {
                actions.setVariant(event.data.variant_id);
            }
        });
        // TODO: potentially get rid of because no longer building billboards programmatically
        setTimeout(() => {
            // for mobile viewer billboards need dynamic height
            if(billboards_enabled) window.parent.postMessage(["set_billboard_height", document.documentElement.scrollHeight], "*"); 
        }, 2000);
    }, [appInitialized, actions, billboards_enabled, elementRef]);

    return (
        <div className={`${classes.mainContent} ${variant_switch_enabled ? 'has_no_pois' : 'has_no_options'} ${reviews ? 'has_tabs' : ''} ${active_tab === 0 ? 'video_tab_active' : ''} ${active_tab === 1 ? 'reviews_tab_active' : ''} ${active_tab === 2 ? 'features_tab_active' : ''} ${clsx({
                [classes.billboard_content] : billboards_enabled || variant_switch_enabled || billboard_variant_switch_enabled,
            })}`} ref={elementRef}>
            { !appInitialized && <LoadingController /> }
            <div className={clsx({
                [classes.default_scene] : true,
                [classes.billboard_scene] : billboards_enabled || variant_switch_enabled || billboard_variant_switch_enabled //only when billboardClassStatus === true
            })}>
                {/*<Canvas />*/}
            <AlternateSlider />
            </div>
            { appInitialized && <ThemeUIController /> }
        </div>
    );
}
